import { useState } from "react";
import { heroKicker, heroTags } from "@/mocks/homeData";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const [hint, setHint] = useState("");

  const handleEnter = () => {
    const value = keyword.trim();
    setHint(
      value
        ? `已锁定「${value}」相关热帖，演示入口，仅供围观`
        : "先输入一个关键词，再进入对应的吃瓜现场",
    );
    setKeyword("");
  };

  return (
    <section id="top" className="relative w-full h-[560px] md:h-[680px] lg:h-[720px]">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20backdrop%2C%20deep%20crimson%20and%20warm%20gold%20ink%20swirls%20on%20dark%20textured%20paper%2C%20dramatic%20cinematic%20lighting%2C%20no%20people%2C%20minimal%20artistic%20composition%2C%20high%20contrast%2C%20moody%20magazine%20cover%20style&width=1800&height=1000&seq=heiliaoyiqu-hero-01&orientation=landscape"
          alt="黑料一区 吃瓜热帖排行 主视觉背景"
          title="黑料一区 热门瓜 吃瓜热帖"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-10">
        <span className="inline-flex items-center gap-2 text-background-100 text-xs md:text-sm tracking-[0.3em] uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          {heroKicker}
        </span>

        <h2 className="mt-5 font-heading text-background-50 font-bold leading-tight text-3xl md:text-5xl lg:text-6xl tracking-wide">
          吃瓜热帖排行
          <br />
          热门瓜一网打尽
        </h2>

        <p className="mt-5 max-w-xl text-background-200 text-sm md:text-base leading-relaxed">
          火爆帖与吃瓜排行实时更新，按热度依次排开。标题配一句短摘要，扫一眼就知道值不值得点进去围观。
        </p>

        <div className="mt-8 w-full max-w-xl flex flex-col sm:flex-row items-stretch gap-2 sm:gap-0 sm:rounded-md sm:overflow-hidden sm:bg-background-50">
          <div className="flex-1 flex items-center gap-2 bg-background-50 rounded-md sm:rounded-none px-4 h-12">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") handleEnter();
              }}
              placeholder="搜索你想吃的那个瓜…"
              className="flex-1 h-full bg-transparent outline-none border-0 text-sm text-foreground-900 placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            onClick={handleEnter}
            className="h-12 px-6 whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm font-medium rounded-md sm:rounded-none cursor-pointer transition-colors"
          >
            进区逛逛
          </button>
        </div>

        {hint && (
          <p className="mt-3 text-xs md:text-sm text-accent-300">{hint}</p>
        )}

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2 md:gap-3">
          {heroTags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 rounded-full border border-background-50/30 text-background-100 text-xs md:text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 w-6 h-6 flex items-center justify-center text-background-200">
        <i className="ri-arrow-down-line text-xl animate-bounce"></i>
      </div>
    </section>
  );
}